module.exports.default = {
    "ORDER": "Gutumiza",
    "SCHEDULE.YOU_ARE_ALL_SET": "Byose biri kumurongo",
    "SCHEDULE.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Gahunda yawe iteganijwe ku",
    "SCHEDULE.CUSTOMER_#_MESSAGE": "Muraho #. Nyamuneka tanga gahunda yawe",
    "SCHEDULE.SCHEDULE_NOW": "Saba Gahunda Nonaha",
    "SCHEDULE.DELIVERY_STATUS_UPDATES": "Kumenyesha aho ibitumizwa bigeze",
    "SCHEDULE.EMAIL_UPDATES": "Kumenyesha na imeri",
    "SCHEDULE.SMS_UPDATES": "Kumenyesha na SMS",
    "SCHEDULE.DISABLE_UPDATES": "Sinshaka kwakira amakuru amenyesha",
    "SCHEDULE.STATUS_UPDATE_IN_THE_FOLLOWING": "Ndashaka kwakira amakuru yaho bigeze kubyo natumije biri ahakurikira",
    "OOPS": "Oops!",
    "SOMETHING_WENT_WRONG": "Hari ibitagenze neza.",
    "REFRESH": "Tangiza",
    "PAGE_NOT_FOUND": "Paji ntibonetse",
    "COULD_NOT_FIND_PAGE": "Ntabwo twashoboye kubona paji washakaga.",
    "TRACKING.MESSAGE_DRIVER_FAILED": "Ntishobora kohereza ubutumwa bw'ubusa",
    "TRACKING.MESSAGE_DRIVER_PLACEHOLDER": "Nyamuneka andika ubutumwa bwawe ku mushoferi",
    "TRACKING.SEND": "Ohereza",
    "TRACKING.ARRIVING_AT": "Aragera i",
    "TRACKING.ETA": "ETA",
    "TRACKING.MIN": "iminota",
    "TRACKING.MAP": "Ikarita",
    "TRACKING.SATELLITE": "Satelite",
    "TRACKING.TERRAIN": "Imbuga",
    "TRACKING.DRIVER_ARRIVED_MESSAGE": "Muraho, Nahageze!",
    "TRACKING.DRIVER_ARRIVED_AT_MESSAGE": "Umushoferi wawe, yageze i",
    "COMPLETED": "Byarangiye",
    "RATING.SKIP": "Simbuka",
    "RATING.WHAT_WENT_WELL": "Ni iki cyagenze neza?",
    "RATING.WHAT_WENT_WRONG": "Ni iki kitagenze neza?",
    "RATING.THANK_YOU": "Murakoze",
    "RATING.FOR_USING_OUR_SERVICE": "Kubwo gukoresha serivisi zacu!",
    "RATING.HOW_WAS_YOUR_DELIVERY": "Serivisi yo kukuzanira ibintu wayibonye ute?",
    "RATING.WHAT_WAS_YOUR_EXPERIENCE": "Nyamuneka dufashe kunoza serivisi zacu utanga amanota kuko wabibonye",
    "SCHEDULE.RATE_US": "Duhe amanota",
    "TERM_OF_USE": "Amabwiriza yo gukoresha",
    "PRIVACY_POLICY": "Politiki Yibanga",
    "SHARING_MY_LOCATION": "Gusangiza aho uherereye",
    "SHARING_LOADING": "Gusangiza biri kuza",
    "REQUIRED_FIELD_MESSAGE": "Uyu mwanya ningombwa kuzuzwa",
    "CONTACT_NAME": "Izina",
    "PHONE_NUMBER": "Nimero ya terefone",
    "EMAIL_ADDRESS": "Aderesi ya imeri",
    "SEND": "Ohereza",
    "FORWARD.THIS_ORDER": "Hererekanya ubu busabe",
    "FORWARD.TO_CONTACT": "Buhereze kuri nimero",
    "FORWARD.ARE_YOU_SURE_MESSAGE": "Uzi neza ko ushaka guhererekanya ubu busabe?",
    "FORWARDED.HAS_DELIVERY_FORWARDED_DELIVERY": "yaguhereje ibitumizwa",
    "FORWARDED.ARE_YOU_SURE_MESSAGE": "Uzi neza ko ushaka kwanga ubu busabe?",
    "ACCEPT": "Emeza",
    "REJECT": "Anga",
    "PICKUP.SET_PICKUP_TIME": "Ndi mu nzira",
    "PICKUP.IVE_ARRIVED": "Nahageze",
    "PICKUP.PICKUP_ETA_SET_FAILED": "Oops! hari ibitagenze neza",
    "PICKUP.ETA_SET_FAILED_DESCRIPTION": "Nyamuneka ongera ugerageze.",
    "PICKUP.MIN": "iminota",
    "PICKUP.SHOW_THIS_NUMBER": "Erekana iyi numero kubanditsi kugirango wakire ibyo watumije",
    "PICKUP.IM_OUTSIDE": "Ndi hano",
    "PICKUP.LET_THEM_KNOW_YOUR_OUTSIDE?": "Utumenyeshe nugera hano.",
    "PICKUP.I_WILL_ARRIVE_AT": "Nzahagera saa",
    "PICKUP.PICKUP_ETA_SUCCESSFULLY_SET": "Igihe cyo gufata cyashyizweho neza",
    "PICKUP.IN": "Mu",
    "PICKUP.TO": "Kuri",
    "PICKUP.COLLECT": "Ubusabe bwakusanyijwe",
    "PICKUP.SELECT_METHOD_OF_TRANSPORT": "Hitamo uburyo bwo gutwara",
    "PICKUP.CONFIRM_METHOD_OF_TRANSPORT": "Emeza uburyo bwo gutwara",
    "PICKUP.CANCEL": "Guhagarika",
    "PICKUP.CONFIRM_TIME": "Emeza igihe cyo kuhagera",
    "TRACKING.DRIVER_ROUTE_ONE_STOP_MESSAGE": "Kuri ubu umushoferi asigaje guharagrara rimwe ngo akugereho",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART2": "Aho bahagarara hari kure yawe",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART1": "Kuri ubu umushoferi ari",
    "PICKUP.OK": "Ok",
    "PICKUP.NEXT": "Komeza",
    "PICKUP.SKIP": "Simbuka",
    "CAR_ARRIVED.TITLE": "Igikorwa cya nyuma! Tumenyeshe uko twakubona:",
    "CAR_ARRIVED.PARKING_SPOT": "Agace ka parikingi / nimero y'umwanya",
    "CAR_ARRIVED.LICENSE_PLATE": "Purake y'ikinyabiziga",
    "CAR_ARRIVED.VEHICLE_MODEL": "Ubwoko bw'imodoka n'nwayikoze ",
    "CAR_ARRIVED.VEHICLE_COLOR": "Ibara ry'imodoka",
    "CAR_ARRIVED.REMEMBER": "Ibuka amakuru y'imodoka yanjye",
    "CAR_ARRIVED.PARKING_SPOT_EXAMPLE": "(Urugero: C - 49)",
    "CAR_ARRIVED.LICENSE_PLATE_EXAMPLE": "(Urugero: 195-Qud)",
    "CAR_ARRIVED.VEHICLE_MODEL_EXAMPLE": "(Urugero: Ford Bronco)",
    "CAR_ARRIVED.VEHICLE_COLOR_EXAMPLE": "(Urugero: Ubururu)",
    "REDIRECT_PICKUP.TO": "Kuri",
    "REDIRECT_PICKUP.CONFIRM_TITLE": "Hindura ahantu babifatira?",
    "REDIRECT_PICKUP.SUCCESS_TITLE": "Aho babifatira hahinduwe neza",
    "REDIRECT_PICKUP.FAILED_TITLE": "Ntibishobotse guhindura ahantu yo gufatira ibintu",
    "REDIRECT_PICKUP.FAILED_DESCRIPTION": "Hari ibitagenze neza",
    "REDIRECT_PICKUP.OK": "Ok",
    "REDIRECT_PICKUP.KM": "km",
    "REDIRECT_PICKUP.SELECT_PICKUP_LOCATION": "Hitamo aho bafatira",
    "REDIRECT_PICKUP.SET_AS_PICKUP_LOCATION": "Hemeze nkaho bafatira bintu",
    "REDIRECT_PICKUP.PICKUP_OPTIONS": "Amahitamo",
    "SOON": "Vuba",
    "TRACKING.WANT_TO_CALL_YOUR_DRIVER": "Urashaka guhamagara umushoferi wawe?",
    "GLOBAL.CALL": "Hamagara",
    "GLOBAL.CANCEL": "Guhagarika",
    "﻿PICKUP.SET_PICKUP_TIME": "Ndi munzira",
    "RATING.PROOF_OF_DELIVERY_MESSAGE": "Ibicuruzwa byawe biragutegereje hanze y'umuryango wawe!",
    "SCHEDULED.THANKS_FOR_USING": "Urakoze gukoresha {{merchant_name}}",
    "SCHEDULED.SHIPMENT_IN_TRANSIT": "Ibitumizwa byawe {{external_id} biri muri nzira",
    "SCHEDULED.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Ibyo mwatumije biteganijwe",
    "Submit": "Tanga",
    "RATING.SELECT_STARS_BEFORE_SUBMIT": "Kuduha amanota, banza uhitemo inyenyeri",
    "PICKUP.SHOW_ID": "Erekana ID",
    "TRACKING.ESTIMATED_TIME_ARRIVAL": "Igihe cyo Kuhagera giteganijwe",
    "OPEN_MENU": "Fungura Menu",
    "CLOSE_MENU": "Funga Menu",
    "MAP_AUTO_CENTER": "Shyira Ikarita hagati na hagati",
    "MAP_SETTINGS": "Igenamiterere y'ikarita",
    "ZOOM_OUT": "Kwegeza amashusho inyuma",
    "ZOOM_IN": "Kwiyegereza amashusho",
    "TRACKING.CALL_DRIVER": "Hamagara Umushoferi",
    "TRACKING.MESSAGE_DRIVER": "Andikira umushoferi",
    "PICKUP.SELECT_TIME_TO_CONFIRM": "Emeza igihe uhagerera gufata ibintu",
    "PICKUP.SET_OR_ARRIVE_DESCRIPTION": "Ntabwo dushaka ko utegereza.\nTumenyeshe mugihe uri munzira cyangwa uhageze:",
    "SCHEDULE.TIME_ZONE_TEXT": "Isaha mpuzabihugu yawe",
    "TRACKING.THANKS_MESSAGE_SUBTITLE": "Turimo kubikoraho!",
    "TRACKING.THANKS_MESSAGE_TEXT": "Turimo gukusanya ibintu byawe, mukanya gato umukozi wacu araba ari ku modoka yawe",
    "TRACKING.THANKS_MESSAGE_TITLE": "Urakoze kwinjira",
    "TRACKING.CLICK_COLLECT_MESSAGE_TEXT": "Nyamuneka jya aho bakirira ibintu mwiduka ryawe aho ibyo watumije byiteguye gukusanywa",
    "CANCEL_ORDER": "Guhagarika ubusabe",
    "CANCELLATION_VALIDATION_TITLE": "Uzi neza ko ushaka guhagarika ubu busabe?",
    "CANCELLATION_VALIDATION_BACK": "Subira inyuma",
    "CANCELLATION_VALIDATION_YES": "Yego",
    "CANCEL_SUCCESS": "Twahagaritse ubusabe bwawe",
    "CANCEL_PAST_ALLOWED": "Igihe cyo guhagarika ubusabe cyarenze",
    "CANCEL_ERROR": "Ntabwo twashoboye guhagarika ibyo watumije",
    "RATING.FREE_TEXT_COMMENT": "Tubwire ibirenzeho",
    "RATING.ORDER_DELIVERED_GREEN": "Twabagejejeho ibyo mwatumije hamwe n'imodoka itangiza ibidukikije",
    "CX_ORDER_STATUS.CONFIRMED": "Gutumiza byemejwe. Turi kubikoraho.",
    "CX_ORDER_STATUS.RECEIVED": "Ubusabe bwakiriwe. Tuzavugana vuba.",
    "CX_ORDER_STATUS.FINDING_DRIVER": "Turi kubashakira umushoferi",
    "CX_ORDER_STATUS.DRIVER_FOUND": "Umushoferi uzana ubusabe bwanyu yabonetse",
    "CX_ORDER_STATUS.PICKING_UP": "Turimo gufata ubusabe bwawe nonaha.",
    "CX_ORDER_STATUS.WAY_TO_PICKUP": "Turi munzira tujya gufata ibyo watumije.",
    "CX_ORDER_STATUS.ON_PREVIOUS_DELIVERY": "Turikurangiza gushyikiriza abasabye mbere.",
    "CX_ORDER_STATUS.WAY_TO_DROPOFF": "Ibyo mwatumije byawe biri kuza iwawe nonaha!",
    "CX_ORDER_STATUS.ARRIVED": "Ibyo mwatumije byahageze byahageze!",
    "TRACKING.DELIVERY_STATUS_TITLE": "Uko kukuzanira ibintu bihagaze",
    "CONFIGURATION.TAGS.SHOW_DELIVERY_STATUS": "Erekana uko gushyira ibintu abakiliya bihagaze",
    "CONFIRM": "Emeza",
    "FLOW_OPTIONS.TITLE": "Nigute ushaka kwakira ibyo watumije?",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_LABEL": "Byashyikirijwe imodoka yawe ahantu hagenwe",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_TEXT": "Ku ruhande rw'umuhanda",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_LABEL": "Kwakirira mu iduka cyangwa ahantu hashyizweho",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_TEXT": "Kanda & Ukusanye",
    "RATING_STAR_ALT": "",
    "RATING_STAR_ALT_ONE": "",
    "RATING_STAR_ALT_TWO": "",
    "TRACKING.ARRIVING_IN_ARIA_LABEL": "",
    "TRACKING.MAP_CONTAINER_ARIA_LABEL": "",
    "SCHEDULE.EXTERNAL_ID_INFO": "",
    "SCHEDULE.TASK_NOTE_LABEL": "",
    "SCHEDULE.CANCEL_NOTE_INPUT": "",
    "DELIVERY_WAS_CANCELLED": ""
};
	